import { createRoute } from '@tanstack/react-router';
import { onboardingParentRoute } from 'pages/shared/Onboarding/onboardingParentRoute';

export const onboardingCreateProfileRoute = createRoute({
  getParentRoute: () => onboardingParentRoute,
  path: '/create_profile',
}).lazy(() =>
  import('pages/shared/Onboarding/CreateProfile/CreateProfilePage').then((d) => d.Route)
);
